import { Application, ApplicationById } from '~/types';
import axios from './axios';

export const getApplications = () => {
  return axios.get<Application[]>('/applications').then((res) => res.data);
};

export const getApplicationById = (id: string) => {
  return axios.get<ApplicationById>(`/applications/${id}`).then((res) => res.data);
};

export const startApplication = (type: string) => {
  return axios.post('/applications', { type }).then((res) => res.data);
};
